import { Icons, cn } from "../../shared/ui";

import type { ChangeTileKind } from "./tileKind";

const TILE: Record<
  ChangeTileKind,
  { className: string; glyph: typeof Icons.Plus }
> = {
  added: { className: "bg-success-bg text-success", glyph: Icons.Plus },
  hidden: { className: "bg-warning-bg text-warning", glyph: Icons.Close },
  changed: { className: "bg-accent-subtle text-accent-fg", glyph: Icons.Edit },
  blocked: { className: "bg-error-bg text-error", glyph: Icons.Alert },
};

/** 28px rounded icon tile of a change row. */
export function ChangeTile({ kind }: { kind: ChangeTileKind }) {
  const { className, glyph: Glyph } = TILE[kind];
  return (
    <span
      aria-hidden="true"
      data-tile={kind}
      className={cn(
        "flex size-7 shrink-0 items-center justify-center rounded-lg",
        className,
      )}
    >
      <Glyph size={16} />
    </span>
  );
}
